import Model from '../orm/Model'

export default class StudentEvent extends Model {
    
    static entity = 'student_event'
  
    static primaryKey = ['student_id', 'event_id']
  
    static fields () {
        return {
            student_id: this.attr(null),
            event_id: this.attr(null)
        }
    }
}